module.exports = __webpack_public_path__ + "static/img/eat-type-item-02.fa0d9b41.png";